var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$prismic.isReady)?_c('div',{staticClass:"layout"},[_c('Transition',{attrs:{"name":"layout__view","mode":"out-in"}},[_c('RouterView',{key:_vm.$route.name,staticClass:"layout__view"})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }